// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, EventEmitter, Input, Output } from '@angular/core';
import {ID3EPolicy} from '../../../../types/d3ePolicy';
import { ConfigurationService } from 'src/services/configuration-service';

@Component({
    selector: 'app-pba-info',
    templateUrl: './pba-info.component.html',
    standalone: false
})
export class PbaInfoComponent {
  @Input() d3ePolicy: ID3EPolicy;
  @Output() onChanged:  EventEmitter<void> = new EventEmitter<void>();

  constructor(
    public configurationService: ConfigurationService
  ) {
  }

  onPbaInfoChanged() {
    this.onChanged.emit();
  }
}
